<p><a [routerLink]="route" [queryParams]="getTotalQueryParams()">{{total || 0}}</a>/<a [routerLink]="route" [queryParams]="getActiveQueryParams()">{{active || 0}}</a></p>
